import { getProspectReference } from "@utils/storage";
import { getEndpoint } from "./endpoint";

const MS_NAME = "acquisition-prospects";

export const CREATE_PROSPECT_ROUTE = `${getEndpoint(MS_NAME)}prospect`;

export const updateTermsAndConditionRouteAcquisitionProspect = () =>
    `${getEndpoint(MS_NAME)}prospect/${getProspectReference()}/carts/terms-and-conditions`;
